import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['input', 'select']

  filename = null;
  connect() {
    this.filename;
    this.fileReader = new FileReader();
    this.selectTarget.addEventListener('dragenter', (e) => this.onDragEnter(e))
    this.selectTarget.addEventListener('dragleave', (e) => this.onDragLeave(e))
    this.selectTarget.addEventListener("dragover", function(event) {
      event.preventDefault();
    });
    this.selectTarget.addEventListener('drop', (e) => this.onDrop(e))
    this.preview = document.querySelector('.website-previewer iframe').contentWindow;
    this.slist(document.getElementById("uploaded-images"));
  }

  upload_image(e) {
    let uploadedImages = document.getElementById("uploaded-images");
    if(uploadedImages.childElementCount + e.target.files.length < 7){
      for(let i = 0; i < e.target.files.length; ++i ){

        const filename = e.target.files[i].name;
  
        const fileReader = new FileReader();
        fileReader.addEventListener('load', (event) => {
          let blankNode = document.getElementById("blank-image").cloneNode(true);
        
          blankNode.querySelector('.image').src = event.target.result;
          blankNode.querySelector('.modalImage').src = event.target.result;
          blankNode.querySelector('.filename').innerText = filename;
  
          uploadedImages.appendChild(blankNode);
        
          if(uploadedImages.childElementCount == 6){
            this.selectTarget.classList.add("hidden");
          }
          this.updatePreview();
          this.slist(document.getElementById("uploaded-images"));
        });
  
        fileReader.readAsDataURL(e.target.files[i]);
      }
    }else {
      alert("You can only upload 6 pictures!");
    }
  }

  onDragEnter(e) {
    e.preventDefault();
    this.selectTarget.classList.add('drag-over');
  }

  onDragLeave(e) {
    e.preventDefault()
    this.selectTarget.classList.remove('drag-over')
  }

  onDrop(e) {
    e.preventDefault();
    let uploadedImages = document.getElementById("uploaded-images");
    if(uploadedImages.childElementCount + e.dataTransfer.files.length < 7){
      this.inputTarget.files = e.dataTransfer.files
      this.fileReader.readAsDataURL(this.inputTarget.files[0])
      for(let i = 0; i < e.dataTransfer.files.length; ++i ){

        const filename = e.dataTransfer.files[i].name;

        const fileReader = new FileReader();
        fileReader.addEventListener('load', (event) => {
          let blankNode = document.getElementById("blank-image").cloneNode(true);
        
          blankNode.id = uploadedImages.childElementCount;
          blankNode.querySelector('.image').src = event.target.result;
          blankNode.querySelector('.modalImage').src = event.target.result;
          blankNode.querySelector('.filename').innerText = filename;

          uploadedImages.appendChild(blankNode);
        
          if(uploadedImages.childElementCount == 6){
            this.selectTarget.classList.add("hidden");
          }
          this.updatePreview();
          this.slist(document.getElementById("uploaded-images"));
        });

        fileReader.readAsDataURL(e.dataTransfer.files[i]);
      }
    }else {
      alert("You can only upload 6 pictures!");
    }
    this.selectTarget.classList.remove('drag-over');
    this.slist(document.getElementById("uploaded-images"));
  }
  updatePreview() {
    let images = [document.getElementById("uploaded-images").querySelectorAll(".image")][0];
    let imagesURLs = [];
    for(const img of images){
      imagesURLs.push(img.src);
    }
    this.preview.postMessage({action: 'website_preview:update_slider', target: '[data-preview=gallery]', value: imagesURLs})
  }

  slist (target) {
    let items = target.getElementsByClassName("image-container"), current = null;
  
    for (let item of items) {
      item.draggable = true;
      
      item.ondragstart = (event) => {
        event.dataTransfer.effectAllowed = "move";
        current = item;
        for (let i of items) {
          if (i != current) { 
            i.classList.add("hint"); 
          }
        }
      };
      
      item.ondragenter = (event) => {
        if (item != current) { 
          item.classList.add("active");
          let currentpos = 0, droppedpos = 0;
          for (let it=0; it<items.length; it++) {
            if (current == items[it]) { currentpos = it; }
            if (item == items[it]) { droppedpos = it; }
          }
          if (currentpos < droppedpos) {
            item.parentNode.insertBefore(current, item.nextSibling);
          } else {
            item.parentNode.insertBefore(current, item);
          }
        }
      };
  
      item.ondragleave = () => {
        item.classList.remove("active");
      };
  
      item.ondragend = () => { 
        for (let it of items) {
          it.classList.remove("hint");
          it.classList.remove("active");
        }
      };
   
      item.ondragover = (event) => { event.preventDefault(); };
   
      item.ondrop = (event) => {
        event.preventDefault();
        this.updatePreview();

        if (item != current) {
          let currentpos = 0, droppedpos = 0;
          for (let it=0; it<items.length; it++) {
            if (current == items[it]) { currentpos = it; }
            if (item == items[it]) { droppedpos = it; }
          }
          if (currentpos < droppedpos) {
            item.parentNode.insertBefore(current, item.nextSibling);
          } else {
            item.parentNode.insertBefore(current, item);
          }
        }
      };
    }
  }
  
  showStockImagesModal(){
    document.getElementById("stock-images-modal").classList.add("is-open");
  }
}